import { Component, HostBinding, Input } from '@angular/core';
import { TooltipPosition } from './tooltip.component';

// NOTE: This is a hack to fix the issue of a warning thrown from a type
// import on a non-AOT build from a file that has multiple exports.
// Ref: https://github.com/angular/angular-cli/issues/2034
type TooltipPos = TooltipPosition;

@Component({
  selector: 'fl-tooltip-content',
  template: `
    <ng-content></ng-content>
  `,
  styleUrls: ['./tooltip-content.component.scss'],
})
export class TooltipContentComponent {
  @Input()
  @HostBinding('attr.data-position')
  position: TooltipPos = 'bottom-center';
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/sq/webapp/src/app/@shared/ui/tooltip/tooltip-content.component.ts